export default __webpack_public_path__ + "53187815d322611afbc92c7ef2a914c8.png";